module.exports = __webpack_public_path__ + "static/fundamentos_exp_01-d4b7f85784e0c9d843966f2c428d4549.jpg";